import BigNumber from 'bignumber.js'
import erc20ABI from 'config/abi/erc20.json'
import masterchefABI from 'config/abi/ChefBami.json'
import linearReleaseABI from 'config/abi/LinearRelease.json'
import multicall from 'utils/multicall'
import farmsConfig from 'config/constants/farms-old'
import { getOldMasterChefAddress } from 'utils/addressHelpers'
import { Farm } from 'state/types'

const CHAIN_ID = process.env.REACT_APP_CHAIN_ID

export const fetchFarmUserAllowances = async (account: string) => {
  const masterChefAdress = getOldMasterChefAddress()

  const calls = farmsConfig.map((farm) => {
    const lpContractAddress = farm.isTokenOnly ? farm.tokenAddresses[CHAIN_ID] : farm.lpAddresses[CHAIN_ID]
    return { address: lpContractAddress, name: 'allowance', params: [account, masterChefAdress] }
  })

  const rawLpAllowances = await multicall(erc20ABI, calls)
  const parsedLpAllowances = rawLpAllowances.map((lpBalance) => {
    return new BigNumber(lpBalance).toJSON()
  })
  return parsedLpAllowances
}

export const fetchFarmUserTokenBalances = async (account: string) => {
  const calls = farmsConfig.map((farm) => {
    const lpContractAddress = farm.isTokenOnly ? farm.tokenAddresses[CHAIN_ID] : farm.lpAddresses[CHAIN_ID]
    return {
      address: lpContractAddress,
      name: 'balanceOf',
      params: [account],
    }
  })

  const rawTokenBalances = await multicall(erc20ABI, calls)
  const parsedTokenBalances = rawTokenBalances.map((tokenBalance) => {
    return new BigNumber(tokenBalance).toJSON()
  })
  return parsedTokenBalances
}

export const fetchFarmsUserLockedBalance = async (account: string) => {
  const calls = farmsConfig.map((farm) => {
    const farmLockerAddress = farm.lockerAddresses[CHAIN_ID]
    return {
      address: farmLockerAddress,
      name: 'lockOf',
      params: [account],
    }
  })

  const rawLockedTokenBalances = await multicall(linearReleaseABI, calls)
  const parsedLockedTokenBalances = rawLockedTokenBalances.map((lockedTokenBalance) => {
    return new BigNumber(lockedTokenBalance).toJSON()
  })
  return parsedLockedTokenBalances
}

export const fetchFarmUserLockedBalance = async (account: string, farm: Farm) => {
  const call = {
    address: farm.lockerAddresses[CHAIN_ID],
    name: 'lockOf',
    params: [account],
  }

  const rawLockedTokenBalances = await multicall(linearReleaseABI, [call])
  const parsedLockedTokenBalances = rawLockedTokenBalances.map((lockedTokenBalance) => {
    return new BigNumber(lockedTokenBalance).toJSON()
  })

  return parsedLockedTokenBalances?.[0] || 0
}

export const fetchFarmUserStakedBalances = async (account: string) => {
  const masterChefAdress = getOldMasterChefAddress()

  const calls = farmsConfig.map((farm) => {
    return {
      address: masterChefAdress,
      name: 'userInfo',
      params: [farm.pid, account],
    }
  })

  const rawStakedBalances = await multicall(masterchefABI, calls)
  const parsedStakedBalances = rawStakedBalances.map((stakedBalance) => {
    return new BigNumber(stakedBalance[0]._hex).toJSON()
  })
  return parsedStakedBalances
}

export const fetchFarmUserEarnings = async (account: string) => {
  const masterChefAdress = getOldMasterChefAddress()

  const calls = farmsConfig.map((farm) => {
    return {
      address: masterChefAdress,
      name: 'pendingBami',
      params: [farm.pid, account],
    }
  })

  const rawEarnings = await multicall(masterchefABI, calls)
  const parsedEarnings = rawEarnings.map((earnings) => {
    return new BigNumber(earnings).toJSON()
  })
  return parsedEarnings
}
